export default "__VITE_ASSET__C9b867ZF__"